<template>
  <div class="main-content visimisi">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title" v-html="title"></h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-content">
      <div class="container about-detail-container">
        <div class="section-content">
          <!-- <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i> -->
          <!-- <div v-else v-html="content"></div> -->
          <div class="row">
            <div class="col-md-5">
              <img v-if="!show_loading" :src="content_image" class="img-about" />
            </div>
            <div class="col-md-7 mt-xs-30">
              <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
              <div v-if="!show_loading" v-html="content"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: false,
      title: "Loading...",
      content: "",
      content_image: "",
    };
  },
  methods: {
    getPage(slug) {
      this.show_loading = true;
      api
        .post(api.route.get.page, { slug })
        .then((res) => {
          let data = res.data;
          let title = data.title;
          let content = data.content;
          let meta = JSON.parse(data.meta);
          let content_image = meta.meta_picture;

          this.title = title;
          this.content = content;
          if (content_image == "")
            this.content_image = require("../assets/no-image.jpg");
          else
            this.content_image =
              content_image != null
                ? content_image
                : require("../assets/no-image.jpg");
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
  watch: {
    "$route.params.slug": {
      deep: true,
      immediate: true,
      handler: function (value) {
        this.getPage(value);
      },
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/pages/FasilitasDetail.vue